export default "__VITE_ASSET__de4ab08d__"